module.exports = __webpack_public_path__ + "img/7.8f25b161.png";